import { render, staticRenderFns } from "./CoachManagement.vue?vue&type=template&id=65cd06de&scoped=true"
import script from "./CoachManagement.vue?vue&type=script&lang=js"
export * from "./CoachManagement.vue?vue&type=script&lang=js"
import style0 from "./CoachManagement.vue?vue&type=style&index=0&id=65cd06de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cd06de",
  null
  
)

export default component.exports